export const FORM_ACTION_TYPES = {
  INIT: "INIT",
  ADD_BOTOES: "ADD_BOTOES",
  CARREGA_FORM: "CARREGA_FORM",
  CARREGA_LISTA: "CARREGA_LISTA",
  SET_SUBMIT: "SET_SUBMIT",
  REMOVE_BOTOES: "REMOVE_BOTOES",
}

export function formReducer(state, action){
  switch (action.type) {
    case FORM_ACTION_TYPES.INIT:
      return action.payload
    case FORM_ACTION_TYPES.ADD_BOTOES:
      return {
        ...state, 
        botoes: (action.payload.substituir ? action.payload.botoes : [...state.botoes, ...action.payload.botoes])
      }
    case FORM_ACTION_TYPES.CARREGA_FORM:
      return {
        ...state, 
        dados: action.payload.dados,
        edicao: action.payload.edicao,
        conteudo: "formulario",
        lista: [],
      }
    case FORM_ACTION_TYPES.CARREGA_LISTA:
      return {
        ...state, 
        edicao: true,
        conteudo: "lista",
        lista: action.payload,
        dados: {}
      }
    case FORM_ACTION_TYPES.SET_SUBMIT:
      return {
        ...state, 
        submitFunction: action.payload
      }
    case FORM_ACTION_TYPES.REMOVE_BOTOES:
      return {
        ...state, 
        botoes: []
      }
    default:
      return state
  }
}